import React, { useState } from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Puff } from 'react-loader-spinner';
import AvgNumberformt from './utils/AvgNumberformt';
import PercentNumberFormat from './utils/PercentNumberFormat';
const StepThree = ({ setStep, step, clientDetails, ownerInfo, setFormData }) => {

  const apiUrl = process.env.REACT_APP_API_URL;
  const { clientkey, merchant_id } = useParams();
  const [loading, setLoading] = useState(false);
  const clientData = JSON.parse(localStorage.getItem('client-details'));
  const numberOfLocations = clientData.number_of_locations;
  console.log('number of locations ', numberOfLocations);


  const initialValues = {
    avgTicket: ownerInfo?.avgTicket ? ownerInfo?.avgTicket : '',
    annualCCSales: ownerInfo?.annualCCSales ? ownerInfo?.annualCCSales : '',
    highest_ticket: ownerInfo?.highest_ticket ? ownerInfo?.highest_ticket : '',
    legal_b2c: ownerInfo?.legal_b2c ? ownerInfo?.legal_b2c : '',
    legal_b2b: ownerInfo?.legal_b2b ? ownerInfo?.legal_b2b : '',
    legal_cnpinternet: ownerInfo?.legal_cnpinternet ? ownerInfo?.legal_cnpinternet : '',
    legal_cnpphoneemail: ownerInfo?.legal_cnpphoneemail ? ownerInfo?.legal_cnpphoneemail : '',
    legal_percentdeliveredover30days: ownerInfo?.legal_percentdeliveredover30days ? ownerInfo?.legal_percentdeliveredover30days : '',
    legal_percentdeliveredsameday: ownerInfo?.legal_percentdeliveredsameday ? ownerInfo?.legal_percentdeliveredsameday : '',
    percentdelievered7days: ownerInfo?.percentdelievered7days ? ownerInfo?.percentdelievered7days : '',
    percentdelivered14days: ownerInfo?.percentdelivered14days ? ownerInfo?.percentdelivered14days : '',
    legal_cp: ownerInfo?.legal_cp ? ownerInfo?.legal_cp : '',
    legal_keyed: ownerInfo?.legal_keyed ? ownerInfo?.legal_keyed : '',
    combined_annual_sales: ownerInfo?.combined_annual_sales ? ownerInfo?.combined_annual_sales : '',
  };

  const validationSchema = Yup.object({
    avgTicket: Yup.number().typeError('Average ticket must be a number').required('Average ticket is required'),
    annualCCSales: Yup.number().typeError('Annual Credit Card Sales must be a number').required('Annual Credit Card Sales is required'),
    highest_ticket : Yup.number().typeError('Highest Ticket must be a number').required('Highest Ticket is required'),
    legal_b2c: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('B2C Transactions must be a number').required('B2C Transactions are required'),
    legal_b2b: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('B2B Transactions must be a number').required('B2B Transactions are required'),
    legal_percentdeliveredover30days: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('Deferred Delivery > 30 Days must be a number').required('Deferred Delivery > 30 Days is required'),
    legal_percentdeliveredsameday: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('Same-Day Delivery must be a number').required('Same-Day Delivery is required'),
    percentdelievered7days: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('Deferred Delivery > 7 Days must be a number').required('Deferred Delivery > 7 Days is required'),
    percentdelivered14days: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('Deferred Delivery > 14 Days must be a number').required('Deferred Delivery > 14 Days is required'),
    legal_cp: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('Card Present must be a number').required('Card Present is required'),
    legal_keyed: Yup.number().min(0, "Should be minimum 0").max(100, "Cannot exceed 100").typeError('Card Not Present must be a number').required('Card Not Present is required'),
    // fax_three: Yup.string()
  });

  // handle form submit form

  const stepThirdHandler = async (values) => {
    try {
      values = {
        ...values,
        avgTicket: Number(values?.avgTicket),
        annualCCSales: Number(values?.annualCCSales),
        highest_ticket: Number(values?.highest_ticket),
        combined_annual_sales: Number(values?.combined_annual_sales),
      }
      let data = {
        ...values,
        merchant_id,
        step: 3,
      }
      if (data.combined_annual_sales === 0){
          data.combined_annual_sales = data.annualCCSales;
      }
      let saveStepTwoToLocalStorage = JSON.stringify({ ...ownerInfo, ...values })
      localStorage.setItem('client-details', saveStepTwoToLocalStorage);
      //  
      setLoading(true);
      if (merchant_id) {
        const response = await axios.post(
          `${apiUrl}/merchant/onboarding/${clientkey}`, data);
        if (response.data.result) {
          toast.success(response?.data?.message);
          setStep(step + 1);
        }
        else {
          toast.error(response?.data?.message);
        }
      }
      else {
        setFormData((pre) => ({ ...pre, ...values }))
        setStep(step + 1);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (typeof (error?.response?.data?.message) === 'object') {
        error?.response?.data?.message?.map((item) => {
          return toast.error(item)
        })
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
      console.log(error);
    }
  }

  // validate fields
  // const ValidateFields = (values) => {
  //   const errors = {};
  //   if (Number(values.legal_b2c) + Number(values.legal_b2b) !== 100) {
  //     errors.legal_b2c = 'B2B and B2C should total 100%';
  //     errors.legal_b2b = 'B2B and B2C should total 100%';
  //   }
  //   if (Number(values.legal_cp) + Number(values.legal_keyed) !== 100) {
  //     errors.legal_cp = 'Card Present and Card Not Present should total 100%';
  //     errors.legal_keyed = 'Card Present and Card Not Present should total 100%';
  //   }
  //   if (Number(values.legal_cnpinternet) + Number(values.legal_cnpphoneemail) !== 100) {
  //     errors.legal_cnpinternet = 'Manual Entry via Phone/Email and internet should total 100%';
  //     errors.legal_cnpphoneemail = 'Manual Entry via Phone/Email and internet should total 100%';
  //   }
  //   if (Number(values.legal_percentdeliveredover30days) + Number(values.legal_percentdeliveredsameday) + Number(values.percentdelivered14days) + Number(values.percentdelievered7days) !== 100) {
  //     errors.legal_percentdeliveredover30days = 'Deferred Delivery greater then 7, 14, 30  Days should total 100%, ';
  //     errors.legal_percentdeliveredsameday = 'Deferred Delivery greater then 7, 14, 30  Days should total 100%, ';
  //     errors.percentdelivered14days = 'Deferred Delivery greater then 7, 14, 30  Days should total 100%, ';
  //     errors.percentdelievered7days = 'Deferred Delivery greater then 7, 14, 30  Days should total 100%, ';
  //   }
  //   return errors;
  // }

  return (
    <div className="">
      <div className='client-logo'>
        <img src={clientDetails?.logo} alt='logo' />
      </div>
      <div className="container all-steps">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            // if (values?.fax_three !== "") { return false; }
            stepThirdHandler(values);
          }}
        >
          {({ values, setFieldValue, field }) => (
            <Form>
              <div className="heading-container">

                <div className="heading-text">
                  <h2>Processing Information</h2>
                </div>
                <div className="heading-ico">
                  <img src="/owner-info.png" alt="Owner Info" />
                </div>
              </div>
              <div className="">
              <div className="row">
                  <AvgNumberformt field={field} setFieldValue={setFieldValue} values={values} name={'annualCCSales'} placeholder={'$'} labelName={'Annual Processing Volume (This Location)'} />
                  { numberOfLocations > 1 ? (
                      <AvgNumberformt field={field} setFieldValue={setFieldValue} values={values} name={'combined_annual_sales'} placeholder={'$'} labelName={'Combined Annual Volume (All Locations)'} />
                  ) : (
                      <div className="input-coll"></div>
                  )}
                <AvgNumberformt field={field} setFieldValue={setFieldValue} values={values} name={'avgTicket'} placeholder={'$'} labelName={'Average Transaction Amount'} />
                <AvgNumberformt field={field} setFieldValue={setFieldValue} values={values} name={'highest_ticket'} placeholder={'$'} labelName={'Highest Transaction Amount'} />
                {/* New Row */}
                <div style={{ width: "100%" }}></div>

                  <div className='input-coll'>
                      <label className='labelStyle'>Approximately what % of your card sales are from business customers?</label>
                      <div className='radio-group'>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_b2b"
                                  value="25"
                                  onClick={() => {
                                      setFieldValue('legal_b2c', 75);
                                      setFieldValue('legal_b2b', 25);
                                  }}
                              />
                              <label className='labelStyle2'>Under 25%</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_b2b"
                                  value="50"
                                  onClick={() => {
                                      setFieldValue('legal_b2c', 50);
                                      setFieldValue('legal_b2b', 50);
                                  }}
                              />
                              <label className='labelStyle2'>25% - 50%</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_b2b"
                                  value="75"
                                  onClick={() => {
                                      setFieldValue('legal_b2c', 25);
                                      setFieldValue('legal_b2b', 75);
                                  }}
                              />
                              <label className='labelStyle2'>50% - 75%</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_b2b"
                                  value="76"
                                  onClick={() => {
                                      setFieldValue('legal_b2c', 25);
                                      setFieldValue('legal_b2b', 75);
                                  }}
                              />
                              <label className='labelStyle2'>75% - 100%</label>
                          </div>
                      </div>
                  </div>
                  <div className='input-coll'>
                      <label className='labelStyle'>Approximately what % of your card sales are the cards present at time of sale?</label>
                      <div className='radio-group'>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_cp"
                                  value="25"
                                  onClick={() => {
                                      setFieldValue('legal_cp', 25);
                                      setFieldValue('legal_keyed', 75)
                                  }}
                              />
                              <label className='labelStyle2'>Under 25%</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_cp"
                                  value="50"
                                  onClick={() => {
                                      setFieldValue('legal_cp', 50);
                                      setFieldValue('legal_keyed', 50);
                                  }}
                              />
                              <label className='labelStyle2'>25% - 50%</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_cp"
                                  value="75"
                                  onClick={() => {
                                      setFieldValue('legal_cp', 75);
                                      setFieldValue('legal_keyed', 25);
                                  }}
                              />
                              <label className='labelStyle2'>50% - 75%</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_cp"
                                  value="76"
                                  onClick={() => {
                                      setFieldValue('legal_cp', 75);
                                      setFieldValue('legal_keyed', 25);
                                  }}
                              />
                              <label className='labelStyle2'>75% - 100%</label>
                          </div>
                      </div>
                  </div>
              </div>
                <br />
                  <div className="row">
                  <div className='input-coll'>
                      <label className='labelStyle'>What is your primary delivery timeframe for goods/services?</label>
                      <div className='radio-group'>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_percentdeliveredsameday"
                                  value="95"
                                  onClick={() => {
                                      setFieldValue('legal_percentdeliveredsameday', 95);
                                      setFieldValue('percentdelievered7days', 5);
                                      setFieldValue('percentdelivered14days', 0);
                                      setFieldValue('legal_percentdeliveredover30days', 0);
                                  }}
                              />
                              <label className='labelStyle2'>Delivered same day as Payment Acceptance</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_percentdeliveredsameday"
                                  value="8"
                                  onClick={() => {
                                      setFieldValue('legal_percentdeliveredsameday', 8);
                                      setFieldValue('percentdelievered7days', 90);
                                      setFieldValue('percentdelivered14days', 2);
                                      setFieldValue('legal_percentdeliveredover30days', 0);
                                  }}
                              />
                              <label className='labelStyle2'>Delivered within 7 days of payment acceptance</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_percentdeliveredsameday"
                                  value="6"
                                  onClick={() => {
                                      setFieldValue('legal_percentdeliveredsameday', 6);
                                      setFieldValue('percentdelievered7days', 4);
                                      setFieldValue('percentdelivered14days', 90);
                                      setFieldValue('legal_percentdeliveredover30days', 0);
                                  }}
                              />
                              <label className='labelStyle2'>Delivered within 14 days of payment acceptance</label>
                          </div>
                          <div className='radio-option'>
                              <Field
                                  type="radio"
                                  name="legal_percentdeliveredsameday"
                                  value="5"
                                  onClick={() => {
                                      setFieldValue('legal_percentdeliveredsameday', 5);
                                      setFieldValue('percentdelievered7days', 5);
                                      setFieldValue('percentdelivered14days', 5);
                                      setFieldValue('legal_percentdeliveredover30days', 85);
                                  }}
                              />
                              <label className='labelStyle2'>Delivered within 30 days of payment acceptance</label>
                          </div>
                      </div>
                  </div>
                {/* <div className="input-coll">
                  <Field type="text" name={`fax_three`} style={{ display: "none !important" }} hidden />
                </div> */}
                <div className='Btn1div'>
                  <button type='button' onClick={() => setStep(step - 1)} className='PrevBtn'>Previous</button>
                  <button type="submit" className='FirstPgBtn '>Continue</button>
                </div>
              </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {loading && (
        <div className="loader-container ">
          <>
            <div className="loader-background"></div> {/* Background blur */}
            <div className="loader-content">
              <Puff color="#ffffff" height={100} width={100} />
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default StepThree;

